import { createAsyncTypes } from 'utils/ActionCreator'

import { QUICK_FILTER } from 'containers/ResolutionCenter/QuickFilters/constants'

import { mitigationOptionItems } from '../constants'

const typeKey = 'Dashboard/Threat Protection/Incident Overview'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', `${typeKey}`)

export const ERROR_MESSAGE = 'The requested data cannot be displayed. Please try again later.'
export const NO_DATA_MESSAGE = 'There are no incidents created within the chosen time frame'

export const LIST_FILTERS_BY_VALUE = {
  INCIDENTS: {
    resolvedByFilter: [
      mitigationOptionItems.resolvedBy.THEMIS_PHISHING,
      mitigationOptionItems.resolvedBy.THEMIS_SPAM,
      mitigationOptionItems.resolvedBy.COMPUTER_VISION,
      mitigationOptionItems.resolvedBy.AUTOMATED_THREAT_DETECTION,
      mitigationOptionItems.resolvedBy.MALWARE_AND_URL_PROTECTION,
      mitigationOptionItems.resolvedBy.ANALYST_PHISHING,
      mitigationOptionItems.resolvedBy.ANALYST_SPAM,
      mitigationOptionItems.resolvedBy.ANALYST_FALSE_POSITIVE,
    ],
  },
  PHISHING: {
    resolvedByFilter: [
      mitigationOptionItems.resolvedBy.THEMIS_PHISHING,
      mitigationOptionItems.resolvedBy.COMPUTER_VISION,
      mitigationOptionItems.resolvedBy.MALWARE_AND_URL_PROTECTION,
      mitigationOptionItems.resolvedBy.ANALYST_PHISHING,
    ],
  },
  SPAM: {
    resolvedByFilter: [
      mitigationOptionItems.resolvedBy.THEMIS_SPAM,
      mitigationOptionItems.resolvedBy.ANALYST_SPAM,
      mitigationOptionItems.resolvedBy.AUTOMATED_THREAT_DETECTION,
    ],
  },
  SAFE: {
    resolvedByFilter: [mitigationOptionItems.resolvedBy.ANALYST_FALSE_POSITIVE],
  },
}

export const RC_QUICK_FILTERS_BY_VALUE = {
  ATO_COMPROMISED: [QUICK_FILTER.ATO, QUICK_FILTER.COMPROMISED],
  ATO_SAFE: [QUICK_FILTER.ATO, QUICK_FILTER.SAFE],
  ATO_UNRESOLVED: [QUICK_FILTER.ATO],
}
